import React from "react";
import styles from "./Accordion.module.css";
import CardWrapper from "../CardWrapper";
import { Button } from "../Modal";
import { ButtonProps } from "../Modal/Button";

interface ButtonCardProps {
  buttonData: ButtonProps[];
}

const ButtonCard: React.FC<ButtonCardProps> = ({ buttonData }) => {
  const buttonBaseStyle: React.CSSProperties = {
    gap: "0.1rem",
  };

  const firstRowButtons = buttonData.slice(0, 2);
  const secondRowButtons = buttonData.slice(2, 4);

  return (
    <div className={styles.buttonCardContainer}>
      <div className={styles.firstRow}>
        {firstRowButtons.map((button, ind) => {
          const modifiedButton = { ...button };
          modifiedButton.customClass = `${
            modifiedButton.customClass || ""
          } truncate-text`;

          const labelText = typeof button.label === 'string' ? button.label : '';
          const isAuditLogs = labelText === "Audit Logs";
          const isPatientDashboard = labelText === "Patient Dashboard";
          const isIntakeForm = labelText === "Intake Form";
          const labelLength = labelText.length;

          let buttonStyleClass = styles.buttonCommon;
          if (isAuditLogs) {
            buttonStyleClass = styles.buttonAuditLog;
          } else if (labelLength > 15) {
            buttonStyleClass = styles.buttonSmallFont;
          } else if (labelLength > 12) {
            buttonStyleClass = styles.buttonReducedPadding;
          } else if (isIntakeForm) {
            buttonStyleClass = styles.buttonIntakeForm;
          }

          modifiedButton.customClass = `${buttonStyleClass} ${modifiedButton.customClass}`;

          const combinedStyle = { ...buttonBaseStyle };

          const iconStyle: React.CSSProperties = {
            height: "2rem",
            width: "2rem",
            marginRight: 0,
            flexShrink: 0,
          };

          if (isPatientDashboard) {
            modifiedButton.customClass = `${modifiedButton.customClass || ''} ${styles.patientDashboardButton}`;
          }

          return (
            <Button
              key={ind}
              span={false}
              submitButtonStyle={combinedStyle}
              iconStyle={iconStyle}
              {...modifiedButton}
            />
          );
        })}
      </div>
      <div className={styles.secondRow}>
        {secondRowButtons.map((button, ind) => {
          const modifiedButton = { ...button };
          modifiedButton.customClass = `${
            modifiedButton.customClass || ""
          } truncate-text`;

          const labelText = typeof button.label === 'string' ? button.label : '';
          const isPatientDashboard = labelText === "Patient Dashboard";
          const isIntakeForm = labelText === "Intake Form";
          const labelLength = labelText.length;

          let buttonStyleClass = styles.buttonCommon;
          if (labelLength > 15) {
            buttonStyleClass = styles.buttonSmallFont;
          } else if (labelLength > 12) {
            buttonStyleClass = styles.buttonReducedPadding;
          } else if (isIntakeForm) {
            buttonStyleClass = styles.buttonIntakeForm;
          }

          modifiedButton.customClass = `${buttonStyleClass} ${modifiedButton.customClass}`;

          const combinedStyle = { ...buttonBaseStyle };

          const iconStyle: React.CSSProperties = {
            height: "2rem",
            width: "2rem",
            marginRight: 0,
            flexShrink: 0,
          };

          if (isPatientDashboard) {
            modifiedButton.customClass = `${modifiedButton.customClass || ''} ${styles.patientDashboardButton}`;
          }

          return (
            <Button
              key={ind}
              span={false}
              submitButtonStyle={combinedStyle}
              iconStyle={iconStyle}
              {...modifiedButton}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ButtonCard;
